'use client';
import { DEFAULT_SKELETON_ANIMATIONS } from '../../../Skeleton.animations.js';

/**
 * Задаёт анимацию присутствия скелетона.
 * */ var getAnimationStyles = function(param) {
    var animation = param.animation, animationOptions = param.animationOptions;
    if (!animation) {
        return {
            animation: "none"
        };
    }
    var animationKeyframes = DEFAULT_SKELETON_ANIMATIONS[animation];
    var _ref = animationOptions || {}, _ref_animationDirection = _ref.animationDirection, animationDirection = _ref_animationDirection === void 0 ? "normal" : _ref_animationDirection, _ref_animationDuration = _ref.animationDuration, animationDuration = _ref_animationDuration === void 0 ? "2.2s" : _ref_animationDuration, _ref_timingFunction = _ref.timingFunction, timingFunction = _ref_timingFunction === void 0 ? "ease-in-out" : _ref_timingFunction, _ref_iterationCount = _ref.iterationCount, iterationCount = _ref_iterationCount === void 0 ? "infinite" : _ref_iterationCount;
    return {
        animation: animationKeyframes,
        animationDirection: animationDirection,
        animationDuration: animationDuration,
        animationTimingFunction: timingFunction,
        animationIterationCount: iterationCount
    };
};

export { getAnimationStyles };
